export const SET_AUTH = "setAuth";

export const CHANGE_VALUES_VOLUMETRIA = "trocarValoresVolumetria";
export const CHANGE_VALUES_PARAMETER_VOLUMETRIA =
  "trocarValoresParametrosVolumetria";
export const CLEAR_VALUES_PARAMETER = "limparValoresPrametros";

export const MOD_STATUS_PESQUISA = "modificaStatusPesquisa";

export const CHANGE_PROCESSO_DETALHADOS = "trocarValorProcessosDetalhados"